module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1a_Image3.67a66306.jpg";